import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetReportingDashboardQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type GetReportingDashboardQuery = { __typename?: 'query_root', customer?: { __typename?: 'customers', id: number, name?: string | null, tier: string, category?: string | null, config?: object | null, effective_config?: object | null, location_id?: number | null, location?: { __typename?: 'locations', id: number, name?: string | null, timezone?: string | null, businesshours: Array<{ __typename?: 'businesshours', id: number, location_id?: number | null, day_of_week?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null }> } | null } | null, movesAggregate: { __typename?: 'moves_aggregate', aggregate?: { __typename?: 'moves_aggregate_fields', count: number } | null }, moves: Array<{ __typename?: 'moves', id: number, active: number, cancel_status?: string | null, canceled_at?: string | null, customer_id?: number | null, payer_id?: number | null, createdat?: string | null, createdBy?: string | null, deliver_by?: string | null, delivery_arrived?: string | null, delivery_started?: string | null, delivery_successful?: string | null, delivery_time?: string | null, driver_id?: number | null, driver_name?: string | null, lane_id?: number | null, lite: boolean, move_type: string, pickup_arrived?: string | null, pickup_started?: string | null, pickup_successful?: string | null, pickup_time?: string | null, ready_by?: string | null, reference_num?: string | null, status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, usecase_key?: string | null, workflowset?: { __typename?: 'workflowsets', id: number, name: string } | null, lane?: { __typename?: 'lanes', id: number, duration_sec?: number | null, distance_miles?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null }, delivery: { __typename?: 'locations', id: number, name?: string | null } } | null, childRideMoves: Array<{ __typename?: 'moves', id: number, status?: string | null, cancel_status?: string | null }> }> };


export const GetReportingDashboardDocument = gql`
    query getReportingDashboard($start: timestamptz!, $end: timestamptz!, $customerId: bigint!, $limit: Int!) {
  customer: customers_by_pk(id: $customerId) {
    id
    name
    tier
    category
    config
    effective_config
    location_id
    location {
      id
      name
      timezone
      businesshours(
        where: {type: {_eq: "business-hours"}}
        order_by: {day_of_week: asc}
      ) {
        id
        location_id
        day_of_week
        is_open
        open_time
        closed_time
      }
    }
  }
  movesAggregate: moves_aggregate(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
  ) {
    aggregate {
      count
    }
  }
  moves(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
    order_by: {pickup_time: asc_nulls_last}
    limit: $limit
  ) {
    id
    active
    cancel_status
    canceled_at
    customer_id
    payer_id
    createdat
    createdBy
    deliver_by
    delivery_arrived
    delivery_started
    delivery_successful
    delivery_time
    driver_id
    driver_name
    lane_id
    lite
    move_type
    pickup_arrived
    pickup_started
    pickup_successful
    pickup_time
    ready_by
    reference_num
    status
    consumer_name
    consumer_phone
    consumer_pickup
    usecase_key
    workflowset {
      id
      name
    }
    lane {
      id
      duration_sec
      distance_miles
      pickup {
        id
        name
      }
      delivery {
        id
        name
      }
    }
    childRideMoves: childMoves(where: {move_type: {_eq: "ride"}, active: {_eq: 1}}) {
      id
      status
      cancel_status
    }
  }
}
    `;

/**
 * __useGetReportingDashboardQuery__
 *
 * To run a query within a React component, call `useGetReportingDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingDashboardQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetReportingDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetReportingDashboardQuery, GetReportingDashboardQueryVariables> & ({ variables: GetReportingDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>(GetReportingDashboardDocument, options);
      }
export function useGetReportingDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>(GetReportingDashboardDocument, options);
        }
// @ts-ignore
export function useGetReportingDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>;
export function useGetReportingDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportingDashboardQuery | undefined, GetReportingDashboardQueryVariables>;
export function useGetReportingDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>(GetReportingDashboardDocument, options);
        }
export type GetReportingDashboardQueryHookResult = ReturnType<typeof useGetReportingDashboardQuery>;
export type GetReportingDashboardLazyQueryHookResult = ReturnType<typeof useGetReportingDashboardLazyQuery>;
export type GetReportingDashboardSuspenseQueryHookResult = ReturnType<typeof useGetReportingDashboardSuspenseQuery>;
export type GetReportingDashboardQueryResult = Apollo.QueryResult<GetReportingDashboardQuery, GetReportingDashboardQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (customer, movesAggregate, moves): returns the full response object.
 * @source {@link src/features/reporting/queries/getReportingDashboard.query.gql}
 */
export async function getReportingDashboard(
  variables: GetReportingDashboardQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetReportingDashboardQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetReportingDashboardQuery>(
    GetReportingDashboardDocument,
    variables,
    requestOptions
  )
}